const MOST_POPULAR_VEHICLES = (pagePath, model) => ({
    category: 'behavior_showroom_most_popular_vehicles',
    action: 'click',
    label: `${pagePath} | ${model}`,
});
const BODY_STYLE = (bodyStyle) => ({
    category: 'ux_showroom_body_style',
    label: `${bodyStyle.toUpperCase()}`,
});
const SORT_BY = (pagePath, sortByWhat) => ({
    category: 'ux_showroom_sort_by',
    action: 'click',
    label: `${pagePath} | ${sortByWhat}`,
});
const ADJUST_MY_PAYMENT = (model) => ({
    category: 'ux_showroom_adjust_payment',
    action: 'click',
    label: `${model}`,
});
const PREPARE_YOUR_VISIT_CTA_NEW = (model) => ({
    category: 'ux_showroom_prepare_visit_cta_new',
    action: 'click',
    label: `${model}`,
});
const PREPARE_YOUR_VISIT_PROCESS_ENDED_NEW = (model) => ({
    category: 'ux_showroom_prepare_visit_process_ended_new',
    action: 'sent',
    label: `${model}`,
});
const PREPARE_YOUR_VISIT_CTA_USED = (model) => ({
    category: 'ux_showroom_prepare_visit_cta_used',
    action: 'click',
    label: `${model}`,
});
const PREPARE_YOUR_VISIT_PROCESS_ENDED_USED = (model) => ({
    category: 'ux_showroom_prepare_visit_process_ended_used',
    action: 'sent',
    label: `${model}`,
});
const RESERVE_IT_NOW_CTA_NEW = (model) => ({
    category: 'ux_showroom_reserve_it_now_cta_new',
    action: 'click',
    label: `${model}`,
});
const RESERVE_IT_NOW_PROCESS_ENDED_NEW = (model) => ({
    category: 'ux_showroom_reserve_it_now_process_ended_new',
    action: 'sent',
    label: `${model}`,
});
const RESERVE_IT_NOW_CTA_USED = (model) => ({
    category: 'ux_showroom_reserve_it_now_cta_used',
    action: 'click',
    label: `${model}`,
});
const RESERVE_IT_NOW_PROCESS_ENDED_USED = (model) => ({
    category: 'ux_showroom_reserve_it_now_process_ended_used',
    action: 'sent',
    label: `${model}`,
});
const EVALUATE_YOUR_PAYMENTSVDP = () => ({
    category: '',
    action: '',
    label: `pages VDP`,
});
const EVALUATE_MY_VEHICLE_CTA = (model) => ({
    category: 'ux_showroom_evaluate_my_vehicle_cta',
    action: 'click',
    label: `${model}`,
});
const ADD_TO_GARAGE_CTA_NEW = (model) => ({
    category: 'engagement_showroom_add_to_garage_cta_new',
    action: 'click',
    label: `${model}`,
});
const ADD_TO_GARAGE_CTA_USED = (model) => ({
    category: 'engagement_showroom_add_to_garage_cta_used',
    action: 'click',
    label: `${model}`,
});
const SPECS_SEE_ALL = (model) => ({
    category: 'ux_showroom_specs_sell_all',
    action: 'click',
    label: `${model}`,
});
const ADD_OR_MODIFY_ACCESSORIES_AND_OPTIONS = (model) => ({
    category: 'ux_showroom_add_modify_accessories_options',
    action: 'click',
    label: `${model}`,
});
const PREVIOUS_STEP_BTN = (pagePath, model) => ({
    category: 'ux_showroom_previous_step_btn',
    action: 'click',
    label: `${pagePath} | ${model}`,
});
const SEE_THE_COLLECTION = (model) => ({
    category: 'ux_showroom_see_the_collection',
    action: 'click',
    label: `${model}`,
});
const PAYMENT_TYPE = (paymentType) => ({
    category: 'ux_showroom_payment_type',
    action: 'click',
    label: `${paymentType}`,
});
const INITIAL_CASH_DOWN = (initialCashDownFilter) => ({
    category: 'ux_showroom_initial_cash_down',
    initialCashDownFilter,
});
const TARGET_PAYMENT = (targetPaymentValue) => ({
    category: 'ux_showroom_target_payment',
    targetPaymentValue,
});
const PREFERRED_FREQUENCY = (preferredFrequency) => ({
    category: 'ux_showroom_preferred_frequency',
    preferredFrequency,
});
const MAXIMUM_TERM = (maxTerm) => ({
    category: 'ux_showroom_maximum_term',
    maxTerm,
});
const EXCHANGE_VALUE__USED_CAR = (pagePath) => ({
    category: 'ux_showroom_exchange_value',
    action: 'click',
    label: `${pagePath}`,
});
const OWE_ON_TRADE = (oweOnTrade) => ({
    category: 'ux_showroom_owe_on_trade',
    oweOnTrade,
});
const LAYER_NAVIGATION__FILTERS = (pagePath, filter) => ({
    category: 'ux_showroom_layer_navigation_filter',
    label: `${pagePath} | ${filter}`,
});
const LOAD_MORE_BTN = (pagePath) => ({
    category: 'ux_showroom_load_more_btn',
    action: 'click',
    label: `${pagePath}`,
});
const ADDITIONNAL_PICTURES = (pagePath) => ({
    category: 'ux_showroom_additional_pictures',
    action: 'click',
    label: `${pagePath}`,
});
const USED_VDP_PICTURES = (pagePath) => ({
    category: 'ux_showroom_used_vdp_pictures',
    action: 'click',
    label: `${pagePath}`,
});
const USED_VDP_PICTURES__NEXT = (pagePath) => ({
    category: 'ux_showroom_used_vdp_pictures_next',
    action: 'click',
    label: `${pagePath}`,
});
const CARFAX_REPORT = (pagePath) => ({
    category: 'ux_showroom_carfax_report',
    action: 'click',
    label: `${pagePath}`,
});

const TRADE_IN_SELF_INSPECT = (pagePath) => ({
    category: 'ux_showroom_tradein_self_inspect',
    action: 'click',
    label: `${pagePath}`,
});

const SEARCH_BAR = (query) => ({
    category: 'ux_showroom_searchbar_query',
    query,
});

const COLOURS = (filterColour) => ({
    category: 'ux_showroom_coulours_filter',
    filterColour,
});

const MAKES = (filterMake) => ({
    category: 'ux_showroom_makes_filter',
    filterMake,
});

const TRADE_IN_VALUE = (tradeInValueFilter) => ({
    category: 'ux_showroom_trade_in_filters',
    tradeInValueFilter,
});

const INVENTORY_LISTING = (sortBy) => ({
    category: 'ux_showroom_inventory_listing_sort_by',
    sortBy,
});

const YEAR_SELECTION = (model, year) => ({
    category: 'ux_showroom_vehicle_builder_year_selection',
    model,
    year,
});

const TRIM_SELECTION = (trim, model, year) => ({
    category: 'ux_showroom_vehicle_builder_trim_selection',
    trim,
    model,
    year,
});

const EXTERIOR_COLOUR = (extColour, model, year) => ({
    category: 'ux_showroom_vehicle_builder_ext_colour_selection',
    extColour,
    model,
    year,
});

const INTERIOR_COLOUR = (intColour, model, year) => ({
    category: 'ux_showroom_vehicle_builder_color_int_selection',
    intColour,
    model,
    year,
});

const ENGINE = (engine, model, year) => ({
    category: 'ux_showroom_vehicle_builder_engine_selection',
    engine,
    model,
    year,
});

const COMFORT = (comfort, model, year) => ({
    category: 'ux_showroom_vehicle_builder_comfort_selection',
    comfort,
    model,
    year,
});

const OPTION = (option, model, year) => ({
    category: 'ux_showroom_vehicle_builder_option_selection',
    option,
    model,
    year,
});

const ACCESSORY = (accessory, model, year) => ({
    category: 'ux_showroom_vehicle_builder_accessory_selection',
    accessory,
    model,
    year,
});

const REQUEST_INFO_CTA = (model, year) => ({
    category: 'ux_showroom_vehicle_summary_request_more_info_cta',
    model,
    year,
});

const PAYMENT_CALCULATOR_CTA = (model, year) => ({
    category: 'ux_showroom_vehicle_summary_payment_calculator_cta',
    model,
    year,
});

const PAYMENT_CALCULATOR_TYPE = (paymentType, model, year) => ({
    category: 'ux_showroom_vehicle_summary_payment_calculator_type',
    paymentType,
    model,
    year,
});

const PAYMENT_CALCULATOR_DURATION = (paymentDuration, model, year) => ({
    category: 'ux_showroom_vehicle_summary_payment_calculator_duration',
    paymentDuration,
    model,
    year,
});

const PAYMENT_CALCULATOR_FREQUENCY = (paymentFrequency, model, year) => ({
    category: 'ux_showroom_vehicle_summary_payment_calculator_frequency',
    paymentFrequency,
    model,
    year,
});

const PAYMENT_CALCULATOR_INITIAL_CASHDOWN = (initialCashDownSummary, model, year) => ({
    category: 'ux_showroom_vehicle_summary_payment_calculator_initial_cash_down',
    initialCashDownSummary,
    model,
    year,
});

const PAYMENT_CALCULATOR_KM_PLAN = (kmPlan, model, year) => ({
    category: 'ux_showroom_vehicle_summary_payment_calculator_km_plan',
    kmPlan,
    model,
    year,
});

const PAYMENT_CALCULATOR_TRADEINVALUE = (tradeInValueSummary, model, year) => ({
    category: 'ux_showroom_vehicle_summary_payment_calculator_estimated_trade_in',
    tradeInValueSummary,
    model,
    year,
});

const EXPRESS_VISIT = (dateSelected) => ({
    category: 'conv_showroom_express_visit_date',
    dateSelected,
});

const EXPRESS_VISIT_PERIOD = (period) => ({
    category: 'conv_showroom_express_visit_date_period',
    period,
});

const MODELS = (filterModel) => ({
    category: 'ux_showroom_model_filter',
    filterModel,
});

const TRANSMISSION = (filterTransmission) => ({
    category: 'ux_showroom_transmission_filter',
    filterTransmission,
});

const FUEL_TYPE = (filterFuelType) => ({
    category: 'ux_showroom_fuel_type_filter',
    filterFuelType,
});

const DRIVE_TRAIN = (filterDriveTrain) => ({
    category: 'ux_showroom_drivetrain_filter',
    filterDriveTrain,
});

export default {
    MOST_POPULAR_VEHICLES,
    BODY_STYLE,
    SORT_BY,
    ADJUST_MY_PAYMENT,
    PREPARE_YOUR_VISIT_CTA_NEW,
    PREPARE_YOUR_VISIT_PROCESS_ENDED_NEW,
    PREPARE_YOUR_VISIT_CTA_USED,
    PREPARE_YOUR_VISIT_PROCESS_ENDED_USED,
    RESERVE_IT_NOW_PROCESS_ENDED_NEW,
    RESERVE_IT_NOW_PROCESS_ENDED_USED,
    RESERVE_IT_NOW_CTA_NEW,
    RESERVE_IT_NOW_CTA_USED,
    EVALUATE_YOUR_PAYMENTSVDP,
    EVALUATE_MY_VEHICLE_CTA,
    ADD_TO_GARAGE_CTA_NEW,
    ADD_TO_GARAGE_CTA_USED,
    SPECS_SEE_ALL,
    ADD_OR_MODIFY_ACCESSORIES_AND_OPTIONS,
    PREVIOUS_STEP_BTN,
    SEE_THE_COLLECTION,
    PAYMENT_TYPE,
    TARGET_PAYMENT,
    INITIAL_CASH_DOWN,
    PREFERRED_FREQUENCY,
    MAXIMUM_TERM,
    EXCHANGE_VALUE__USED_CAR,
    OWE_ON_TRADE,
    LAYER_NAVIGATION__FILTERS,
    LOAD_MORE_BTN,
    ADDITIONNAL_PICTURES,
    USED_VDP_PICTURES,
    USED_VDP_PICTURES__NEXT,
    CARFAX_REPORT,
    TRADE_IN_SELF_INSPECT,
    SEARCH_BAR,
    COLOURS,
    MAKES,
    TRADE_IN_VALUE,
    INVENTORY_LISTING,
    YEAR_SELECTION,
    TRIM_SELECTION,
    EXTERIOR_COLOUR,
    INTERIOR_COLOUR,
    ENGINE,
    COMFORT,
    OPTION,
    ACCESSORY,
    REQUEST_INFO_CTA,
    PAYMENT_CALCULATOR_CTA,
    PAYMENT_CALCULATOR_TYPE,
    PAYMENT_CALCULATOR_DURATION,
    PAYMENT_CALCULATOR_FREQUENCY,
    PAYMENT_CALCULATOR_INITIAL_CASHDOWN,
    PAYMENT_CALCULATOR_KM_PLAN,
    PAYMENT_CALCULATOR_TRADEINVALUE,
    EXPRESS_VISIT,
    EXPRESS_VISIT_PERIOD,
    MODELS,
    TRANSMISSION,
    FUEL_TYPE,
    DRIVE_TRAIN,
};
